import type { FC, ReactNode } from 'react'

import { useState } from 'react'
import { Menu, X } from 'lucide-react'
import { NAV_LINKS } from '@/constants/site'

export const Logo: FC = (): ReactNode => (
    <a href='/' className='flex items-baseline gap-2 text-white'>
        <span className='text-sm font-bold tracking-[0.2em] uppercase'>Rare Frequency</span>
        <span className='font-serif-accent text-2xl text-amber-300'>Works</span>
    </a>
)

const SiteHeader: FC = (): ReactNode => {
    const [open, setOpen] = useState(false)

    return (
        <header className='sticky top-0 z-40 border-b border-white/10 bg-[#060b14]/85 backdrop-blur'>
            <div className='mx-auto flex h-16 max-w-6xl items-center justify-between px-6'>
                <Logo />

                <nav aria-label='Main' className='hidden md:block'>
                    <ul className='flex items-center gap-7 text-sm font-medium text-slate-300'>
                        {NAV_LINKS.map((link) => (
                            <li key={link.label}>
                                <a href={link.href} className='transition-colors hover:text-cyan-300'>
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>

                <button
                    type='button'
                    className='rounded-lg p-2 text-slate-200 md:hidden'
                    aria-expanded={open}
                    aria-label={open ? 'Close menu' : 'Open menu'}
                    onClick={() => setOpen(!open)}
                >
                    {open ? <X className='size-6' /> : <Menu className='size-6' />}
                </button>
            </div>

            {open && (
                <nav aria-label='Mobile' className='border-t border-white/10 px-6 py-4 md:hidden'>
                    <ul className='flex flex-col gap-1'>
                        {NAV_LINKS.map((link) => (
                            <li key={link.label}>
                                <a href={link.href} className='block rounded-lg px-3 py-3 text-slate-200 hover:bg-white/5'>
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>
            )}
        </header>
    )
}

export default SiteHeader
